module.exports = __webpack_public_path__ + "static/media/pizzaAmigosDerecho.360c11ed.jpeg";